import { GetTripPaymentDetailsForAdminState } from './getTripPaymentDetailsForAdmin.types'

const initialState: GetTripPaymentDetailsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
